import { Col, FormCheck, FormControl, FormLabel, FormSelect, Row } from "react-bootstrap";
import { useState } from "react";
import RollDice from "../dice-rolling";

export default function Grappling() {
    const [isRavenAttack, setIsRavenAttack] = useState(false);
    const [isAdvantaged, setIsAdvantaged] = useState(false);
    const [isTargetGrappledDrifting, setIsTargetGrappledDrifting] = useState(false);
    const [isFromSuccessfulRam, setIsFromSuccessfulRam] = useState(false);
    const [attackerSpeed, setAttackerSpeed] = useState(0);
    const [targetSpeed, setTargetSpeed] = useState(0);
    const [isUngrappleAgainstIronClawRaven, setIsUngrappleAgainstIronClawRaven] = useState(false);
    const [attackerCrewExperience, setAttackerCrewExperience] = useState("ex");
    const [targetCrewExperience, setTargetCrewExperience] = useState("ex");
    const [numAttackingStands, setNumAttackingStands] = useState(1);
    const [numDefendingStands, setNumDefendingStands] = useState(1);

    const [grappleAttemptResult, setGrappleAttemptResult] = useState("");

    function rollForGrapplingUngrappling() {
        // Roll Die
        const roll: number = RollDice(1)[0];

        if (roll === 10) {
            setGrappleAttemptResult("Success");
        } else if (isRavenAttack) {
            // If it's a Raven Attack, we don't care about the die roll modifiers and can determine the result immediately.
            if (roll > 3)
                setGrappleAttemptResult("Success");
            else
                setGrappleAttemptResult("Failure");
        } else {
            // If it's not a Raven Attack, we need to determine the die roll modifiers.
            let modifier = 0;
            let speedDifference = Math.abs(attackerSpeed - targetSpeed);

            if (isAdvantaged)
                modifier += 1;
            if (isTargetGrappledDrifting)
                modifier += 1;
            if (isFromSuccessfulRam)
                modifier += 1;
            if (isUngrappleAgainstIronClawRaven)
                modifier -= 2;
            if (attackerCrewExperience === "ix")
                modifier -= 1;
            if (attackerCrewExperience === "vt")
                modifier += 1;
            if (targetCrewExperience === "vt")
                modifier -= 1;
            if (speedDifference === 3 || speedDifference === 4)
                modifier -= 1;
            if (speedDifference >= 5)
                modifier -= 2;

            // Get the modified roll
            let modifiedRoll: number = roll + modifier;

            // Determine table cell
            let row: number = 0;
            let col: number = 0;

            switch (numAttackingStands) {
                case 1:
                case 2:
                case 3:
                    row = 0;
                    break;
                case 4:
                case 5:
                case 6:
                    row = 1;
                    break;
                case 7:
                case 8:
                case 9:
                    row = 2;
                    break;
                case 10:
                case 11:
                case 12:
                    row = 3;
                    break;
                default:
                    row = 4;
                    break;
            }

            switch (numDefendingStands) {
                case 1:
                case 2:
                case 3:
                    col = 0;
                    break;
                case 4:
                case 5:
                case 6:
                    col = 1;
                    break;
                case 7:
                case 8:
                case 9:
                    col = 2;
                    break;
                case 10:
                case 11:
                case 12:
                    col = 3;
                    break;
                default:
                    col = 4;
                    break;
            }

            // Table
            let table: number[][] = [
                [6, 7, 8, 9, 10],
                [5, 6, 7, 8, 9],
                [4, 5, 6, 7, 8],
                [3, 4, 5, 6, 7],
                [2, 3, 4, 5, 6]
            ];

            // Get the result
            let threshold: number = table[row][col];
            if (modifiedRoll >= threshold)
                setGrappleAttemptResult("Success");
            else
                setGrappleAttemptResult("Failure");
        }
    }


    return (
        <>
            <Row>
                <Col>
                    <h1>Grappling/Ungrappling</h1>
                </Col>
            </Row>
            {grappleAttemptResult === "" ? null : (
                <Row className="p-3 text-center">
                    <Col>
                        <h1 className={grappleAttemptResult === "Success" ? "text-success" : "text-danger"}>{grappleAttemptResult}</h1>
                    </Col>
                </Row>
            )}
            <Row className="my-3">
                <Col>
                    <FormCheck type="checkbox" label="Attempt by Raven" checked={isRavenAttack} onChange={(e) => setIsRavenAttack(e.target.checked)} />
                </Col>
            </Row>
            {!isRavenAttack && (
                <>
                    <Row>
                        <Col>
                            <FormLabel htmlFor="attacker-stand-count">Attacking Stands</FormLabel>
                            <FormSelect id="attacker-stand-count" value={numAttackingStands} onChange={(e) => setNumAttackingStands(parseInt(e.target.value))}>
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                                <option value={3}>3</option>
                                <option value={4}>4</option>
                                <option value={5}>5</option>
                                <option value={6}>6</option>
                                <option value={7}>7</option>
                                <option value={8}>8</option>
                                <option value={9}>9</option>
                                <option value={10}>10</option>
                                <option value={11}>11</option>
                                <option value={12}>12</option>
                                <option value={13}>13+</option>
                            </FormSelect>
                        </Col>
                        <Col>
                            <FormLabel htmlFor="defender-stand-count">Defending Stands</FormLabel>
                            <FormSelect id="defender-stand-count" value={numDefendingStands} onChange={(e) => setNumDefendingStands(parseInt(e.target.value))}>
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                                <option value={3}>3</option>
                                <option value={4}>4</option>
                                <option value={5}>5</option>
                                <option value={6}>6</option>
                                <option value={7}>7</option>
                                <option value={8}>8</option>
                                <option value={9}>9</option>
                                <option value={10}>10</option>
                                <option value={11}>11</option>
                                <option value={12}>12</option>
                                <option value={13}>13+</option>
                            </FormSelect>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col>
                            <FormLabel htmlFor="attacker-speed">Attacker Speed</FormLabel>
                            <FormControl id="attacker-speed" type="number" min={0} value={attackerSpeed} onChange={(e) => setAttackerSpeed(parseInt(e.target.value))} />
                        </Col>
                        <Col>
                            <FormLabel htmlFor="target-speed">Target Speed</FormLabel>
                            <FormControl id="target-speed" type="number" min={0} value={targetSpeed} onChange={(e) => setTargetSpeed(parseInt(e.target.value))} />
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col>
                            <FormLabel htmlFor="attacker-crew-experience">Attacker Crew Quality</FormLabel>
                            <FormSelect id="attacker-crew-experience" value={attackerCrewExperience} onChange={(e) => setAttackerCrewExperience(String(e.target.value))}>
                                <option value={"ix"}>Inexperienced</option>
                                <option value={"ex"}>Experienced</option>
                                <option value={"vt"}>Veteran</option>
                            </FormSelect>
                        </Col>
                        <Col>
                            <FormLabel htmlFor="target-crew-experience">Target Crew Quality</FormLabel>
                            <FormSelect id="target-crew-experience" value={targetCrewExperience} onChange={(e) => setTargetCrewExperience(String(e.target.value))}>
                                <option value={"ix"}>Inexperienced</option>
                                <option value={"ex"}>Experienced</option>
                                <option value={"vt"}>Veteran</option>
                            </FormSelect>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col>
                            <FormCheck
                                type="checkbox"
                                className="mb-3"
                                label="Two or more Grapple attempts on the same target from different ships (each attempt receives this modifier)."
                                checked={isAdvantaged}
                                onChange={(e) => setIsAdvantaged(e.target.checked)}
                            />
                            <FormCheck
                                type="checkbox"
                                className="mb-3"
                                label="Target ship is already Grappled/Drifting."
                                checked={isTargetGrappledDrifting}
                                onChange={(e) => setIsTargetGrappledDrifting(e.target.checked)}
                            />
                            <FormCheck
                                type="checkbox"
                                className="mb-3"
                                label="Grapple attempt from a successful Ramming Ship."
                                checked={isFromSuccessfulRam}
                                onChange={(e) => setIsFromSuccessfulRam(e.target.checked)}
                            />
                            <FormCheck
                                type="checkbox"
                                label="Ungrapple attempt against Iron Claw or Raven."
                                checked={isUngrappleAgainstIronClawRaven}
                                onChange={(e) => setIsUngrappleAgainstIronClawRaven(e.target.checked)}
                            />
                        </Col>
                    </Row>
                </>
            )}
            <Row className="mt-3">
                <Col xs={12}>
                    <button className="btn btn-primary" onClick={() => rollForGrapplingUngrappling()}>Roll for Grappling/Ungrappling</button>
                </Col>
                <Col className="mt-3">
                    <button className="btn btn-danger" onClick={() => setGrappleAttemptResult("")}>Clear Result</button>
                </Col>
            </Row>
        </>
    )
}